<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Escala de Folgas</h5>
                <hr>              

                <TabView @tab-change="verificarCarreamentoCnpjs">					
      				<TabPanel header="Cadastro" class="p-mt-3">
                        <div class="p-col-12 p-md-12" v-if="progresso > 0"> 
                            Aguarde! Atualizando ponto...<i class="pi pi-spin pi-spinner" ></i>
                            <ProgressBar :value="progresso" class="p-mb-2" v-if="progresso > 0"/>
                        </div>
                        <IKFiltroFuncionarioContrato ref="ikFiltroFuncionarios"/>
                        <div class="p-grid p-mt-5">
                            <div class="p-col-12 p-md-6">
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 p-md-12">
                                        <label>Dia(s) da folga</label>
                                        <Calendar v-model="datasSelecionar" :numberOfMonths="2" :showIcon="true" selectionMode="multiple" :manualInput="false"
                                         dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>
                                    </div>                                                        
                                </div>
                                <Button label="Selecionar" icon="pi pi-check" @click="selecionarDatas"/> 
                            </div>
                            <div class="p-col-12 p-md-6">
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 p-md-12">
                                        <label>Dias selecionados</label>
                                        <Listbox v-model="dataSelecionada" @change="excluirData()" :options="datasSelecionadas" optionLabel="dia" listStyle="height:160px" style="width:15em">
                                            <template #option="slotProps">
                                                <div>                                                    
                                                    <span>{{slotProps.option.dia}}</span>
                                                    <Button icon="pi pi-times" title="Excluir" class="p-button-rounded p-button-danger p-button-text p-ml-2"/>
                                                </div>
                                            </template>
                                        </Listbox>
                                    </div>                      
                                </div>
                            </div>
                        </div>
                        <Button label="Salvar" icon="pi pi-check" v-if="permissaoNovo" @click="salvar"/>
      				</TabPanel>
                    <TabPanel header="Folgas" class="p-mt-3">
                        <div class="p-col-12">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-3">
                                    <label>Data início</label>
                                    <Calendar v-model="diaDe" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>
                                </div>  
                                <div class="p-field p-col-12 p-md-3">
                                    <label>Data final</label>               
                                    <Calendar v-model="diaAte" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>
                                </div>                                            
                            </div>                                     
                        </div>
                        <div class="p-col-12">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-5">
                                    <label>Empresa</label>
                                    <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                                        @change="listarCentrosCustos"/>
                                </div>  
                                <div class="p-field p-col-12 p-md-5">
                                    <label>Centro de custo</label>               
                                    <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Todos"
                                        :filter="true" :showClear="true"/>
                                </div>    
                                <div class="p-field p-col-0">
                                    <label style="color:#ffffff">.</label>  
                                    <Button label="Buscar" icon="pi pi-search" @click="listarFolgas"/>
                                </div>                    
                            </div>                                     
                        </div>
                        <DataTable :value="folgas" :filters="filtro" class="p-datatable-sm p-datatable-striped" :paginator="true" :rows="10"
					        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					        :rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}">
                            <template #header>
                                <div class="table-header">			
                                    <div class="p-d-flex p-jc-end">				
                                        <span class="p-input-icon-left">
                                            <i class="pi pi-search" />
                                            <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                                        </span>
                                    </div>
                                </div>
                            </template>                            
                            <Column field="funcionario.cracha" header="Crachá" sortable>
                                <template #body="slotProps">
                                    {{ formatarCracha(slotProps.data.funcionario.cracha) }}
                                </template>	
                            </Column>
                            <Column field="funcionario.nome" header="Nome" sortable></Column>
                            <Column field="data" header="Data" sortable>		
                                <template #body="slotProps">
                                    {{ formatarStringData(slotProps.data.data) }}
                                </template>				
                            </Column>
                            <Column>
                                <template #body="slotProps">                                    
							        <Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>
                                </template>
                            </Column>
                        </DataTable>
      				</TabPanel>
                </TabView>

				<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" /><br/>
						<span>Excluir folga <b>{{ formatarStringData(folgaEditar.data) }}</b></span><br/>
                        <span>De: <b>{{ folgaEditar.funcionario.nome }}</b>?</span>
					</div>
					<template #footer>
						<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
						<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
					</template>
				</Dialog>             
			</div>
		</div>        
    </div>
</template>

<script>
import IKFiltroFuncionarioContrato from '@/components/template/IKFiltroFuncionarioContrato';
import CentroCustoService from '@/service/CentroCustoService';
import FolgaService from '@/service/FolgaService';
import ControlePontoService from '@/service/ControlePontoService.js';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    folgaService: null,
    centroCustoService: null,
    data() {
        return {
            exibirDialogConfirmarExcluir: false,
            permissaoNovo: false,
            permissaoEditar: false,
            permissaoExcluir: false,
            filtro: {},
            folgas: [],
            centrosCustos: [],
            cnpjs: [],
            idCentroCustoSelecionado: null,
            idCnpjSelecionado: null,
            datasSelecionar: [],
            datasSelecionadas:[],
            dataSelecionada: [],            
            diaDe: new Date(),
            diaAte: new Date(),
            folgaEditar: {data: null, funcionario:{nome: ''}},
            localeCalendarBR: localeCalendarBR,
            progresso: 0,
            pararTimeout: false,
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao', 'getPermissoes', 'getCacheEmpresa']),  
        /**
         * 
         */     
        salvar() {
            if(this.datasSelecionadas.length == 0) {
                exibirMensagemSis(this, 'Selecione a(s) data(s)', true);
                return;
            }
            if(this.datasSelecionadas.length > 10) {
                exibirMensagemSis(this, 'Selecione no máximo 10 dias', true);
                return;
            }
            let dados = this.$refs.ikFiltroFuncionarios.getFiltro();
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione o(s) funcionário(s)', true);
                return;
            }
            let funcionarios = [];
            dados.funcionarios.forEach(funcio => {
                funcionarios.push({
                    id: funcio.id,
                    nome: funcio.nome,
                    pis: funcio.pis
                });
            });
            let datas = [];
            this.datasSelecionadas.forEach(dtFolga => {
                datas.push(this.formatarData(dtFolga.data));
            });
            let requisicao = {         
                datas: datas,     
                cnpj: dados.cnpj,
                funcionarios: funcionarios,                
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.folgaService.salvar(requisicao)
            .then(resp => {      
                if(resp.data instanceof Array) {
                    exibirMensagemSis(this, 'Sucesso', false);     
                } else {
                    exibirMensagem(this, resp);   
                } 
                if(resp.data instanceof Array && resp.data.length > 0) {
                    this.atualizarPonto(resp.data);
                } else {
                    this.datasSelecionadas = [];
                    this.dataSelecionada = null;  
                }                                  
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },        
        /**
         * 
         */
        excluir() {
            let cnpjSelecionado = null;
            this.cnpjs.forEach(cnpj => {
                if(this.idCnpjSelecionado == cnpj.id) {
                    cnpjSelecionado = cnpj;
                }
            });
            let folga = {...this.folgaEditar};   
            let funcionario = {...this.folgaEditar.funcionario};          
            let requisicao = {     
                cnpj: cnpjSelecionado,    
                folga: folga,                 
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.folgaService.excluir(requisicao)
            .then(resp => {
                this.limparExcluir();
                if(resp.data instanceof Array) {
                    exibirMensagemSis(this, 'Sucesso', false);     
                } else {
                    exibirMensagem(this, resp);   
                } 
                this.listarFolgas();
                if(resp.data instanceof Array && resp.data.length > 0) {
                    let requisicao = {
                        mes: resp.data[0].mes,
                        ano: resp.data[0].ano,
                        dataInicio: resp.data[0].dataInicio,
                        dataFinal: resp.data[0].dataFinal,
                        cnpj: cnpjSelecionado,
                        funcionario:  {
                            id: funcionario.id,
                            nome: funcionario.nome,
                            pis: funcionario.pis
                        },      
                        usuarioRequisicao: {...this.getDadosRequisicao()},          
                    };
                    this.calcularPeriodoEditado(requisicao);
                }
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        atualizarPonto(rangeDatas) {
            let dados = this.$refs.ikFiltroFuncionarios.getFiltro();            
            let requisicoes = [];                   
            const fabricaRequisicoes = {
                criar: (range, dados) => {
                    return {
                        mes: range.mes,
                        ano: range.ano,
                        dataInicio: range.dataInicio,
                        dataFinal: range.dataFinal,
                        cnpj: dados.cnpj,
                        funcionarios: [],      
                        usuarioRequisicao: this.getDadosRequisicao(),          
                    };
                }
            }
            rangeDatas.forEach(range => {
                let requisicao = fabricaRequisicoes.criar(range, dados);
                requisicoes.push(requisicao);
                let qtd = 0;
                dados.funcionarios.forEach(funcio => {                
                    if(qtd < 5) {                        
                        qtd++;
                    } else {
                        qtd = 1;
                        requisicao = fabricaRequisicoes.criar(range, dados);
                        requisicoes.push(requisicao);
                    }
                    requisicao.funcionarios.push(funcio);
                }); 
            });                 
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.progresso = 1;             
            this.calcularPeriodoEditadoRecursivo(1, requisicoes);
        },
        /**
         * 
         */
        calcularPeriodoEditadoRecursivo(pagina, requisicoes) {     
            if(this.pararTimeout) {
                return;
            }      
            let requisicao = requisicoes[(pagina-1)];          
            this.controlePontoService.calcularPeriodoEditado2(requisicao, 'fdb=f')
            .then(()=>{
                if((pagina + 1) > requisicoes.length) {                       
                    this.progresso = 100;
                    this.datasSelecionadas = [];
                    this.dataSelecionada = null; 
                    setTimeout(() => { this.progresso = 0; }, 1000);
                } else  {
                    this.progresso = Math.trunc((pagina / requisicoes.length)*100);
                    pagina++;
                    setTimeout(() => {
                        this.calcularPeriodoEditadoRecursivo(pagina, requisicoes);
                    }, 500);
                } 
            })
            .catch(erro => {                   
                exibirMensagem(this, erro);
                setTimeout(() => { this.progresso = 0; }, 3000);
            });
        },
        /**
         * 
         */
         calcularPeriodoEditado(requisicao) {           
            this.controlePontoService.calcularPeriodoEditado2(requisicao)
            .then()
            .catch(erro => {exibirMensagem(this, erro)}); 
        },        
        /**
         * 
         */
        listarFolgas() {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }
             let requisicao = {        
                idsCentrosCustos: idsCentrosCustos,
                diaDe: this.formatarData(this.diaDe),
                diaAte: this.formatarData(this.diaAte),              
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.folgaService.listar(requisicao)
				.then(resp => {    
                    this.folgas = resp.data;                    
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },  
        /**
         * 
         */
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },     
        /**
         * 
         */
        selecionarDatas() {
            if(this.datasSelecionar.length > 0) {
                this.datasSelecionar.forEach(data => {
                    let encontrou = false;
                    this.datasSelecionadas.forEach(dtSelect => {
                        if(dtSelect.data.getTime() == data.getTime()) {
                            encontrou = true;
                        }
                    });
                    if(!encontrou) {
                        this.datasSelecionadas.push({dia: data.toLocaleString('pt-br',{dateStyle: 'short'}), data: data});
                    }
                });
            }
            this.datasSelecionar = [];
        },
        /**
         * 
         */
        excluirData() {            
            for(let i = 0; i < this.datasSelecionadas.length; i++) {
                if(this.dataSelecionada.dia == this.datasSelecionadas[i].dia) {
                    this.datasSelecionadas.splice(i, 1);
                    break;
                }
            }            
        },
        /**
         * 
         */
        confirmarExcluir(folga) {
			this.folgaEditar = folga;
			this.exibirDialogConfirmarExcluir = true;
		},
        /**
         * 
         */
		limparExcluir() {
			this.folgaEditar = {data: null, funcionario:{nome: ''}};
			this.exibirDialogConfirmarExcluir = false;
		},
        /**
         * 
         */
        verificarCarreamentoCnpjs(){
            if(this.cnpjs.length == 0) {
                this.listarCnpjs();
            }           
        },
        /**
         * 
         */	
        listarCnpjs() {            
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        /**
         * 
         */
        listarCentrosCustos() {
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
				.then(resp => {                       
                    this.idContratoSelecionado = null;                     
                    this.centrosCustos = []; 
                    let centroCusto = new CentroCusto();
                    centroCusto.nome = 'Todos';
                    this.centrosCustos.push(centroCusto);
                    Array.prototype.push.apply(this.centrosCustos, resp.data);                    
                })
                .catch(erro => {console.log(erro);exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        formatarCracha(cracha) {
            let novo = '';
            let tamanho = cracha.length;
            if(tamanho < 14) {
                let resto = 14 - tamanho;
                for(let i = 0; i < resto; i++) {
                    novo += '0';
                }
            }            
            return novo+cracha;
        },
        /**
         * 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        /**
         * 
         */
        formatarStringData(data) {  
            if(!data || data instanceof Date) {
                return '';
            }        
			let partes = data.split('-');
			return partes[2] + '/' + partes[1] + '/' + partes[0];
		},
        /**
         * 
         */
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
            this.permissaoNovo = permissoes.includes(96);
            this.permissaoEditar = permissoes.includes(107);
            this.permissaoExcluir = permissoes.includes(97);				
		}
    },
    created() {
        this.controlePontoService = new ControlePontoService ();
        this.centroCustoService = new CentroCustoService();
        this.folgaService = new FolgaService();       
    },
    mounted() {        
        this.validarPermissoes();
    },  
    beforeDestroy() {
        this.pararTimeout = true;
    },  
    components: {
        'IKFiltroFuncionarioContrato': IKFiltroFuncionarioContrato,
    }

}
</script>

<style>

</style>